module.exports = __webpack_public_path__ + "img/icon-warning-generic-2.abbe8140.svg";